import { useMemo } from 'react';

import type { AccountId } from '../../generated-types';
import useQueryParam from './useQueryParam';

const useAccountId = (): AccountId | undefined => {
    const accountId = useQueryParam('id');
    return useMemo(() => {
        return accountId ? { value: accountId } : undefined;
    }, [accountId]);
};
export default useAccountId;
